// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3YWJM","header":"Messages_header__1j4MY"};